import { useEffect, useState } from "react";

import "./ArticleSearch.css";

export default function ArticleSearch({
    value,
    onSearch,
}) {
    const [input, setInput] = useState(value || "");

    useEffect(() => {
        setInput(value || "");
    }, [value]);

    function handleSubmit(event) {
        event.preventDefault();

        onSearch(input.trim());
    }

    function handleClear() {
        setInput("");

        onSearch("");
    }

    return (
        <form
            className="article-search"
            onSubmit={handleSubmit}
        >

            <div className="article-search__input-wrapper">

                <span className="article-search__icon">
                    🔍
                </span>

                <input
                    type="text"
                    value={input}
                    onChange={(event) =>
                        setInput(event.target.value)
                    }
                    placeholder="جستجو در مقالات..."
                    aria-label="جستجو در مقالات"
                />

                {input && (
                    <button
                        type="button"
                        className="article-search__clear"
                        onClick={handleClear}
                        aria-label="پاک کردن"
                    >
                        ×
                    </button>
                )}

            </div>

            <button
                type="submit"
                className="article-search__button"
            >
                جستجو
            </button>

        </form>
    );
}